import { url } from "@constants/url-constants";
import { Client } from "@helpers/helpers";
import { API_METHOD } from "@constants/constants";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getProfileData = createAsyncThunk("profile/list", async () => {
  const response = await Client(API_METHOD.GET, url.profile);
  return response.data;
});


